import { gql } from '@apollo/client';
import UPDATE_STUDENT_SETTING_FRAGMENT from '../../fragments/update-student-setting-fragment';

const UPDATE_WDT_STUDENT_LEFT_HANDEDNESS_SETTING = gql`
  mutation updateWdtStudentSettingLeftHandedness(
    $data: [UpdateWdtStudentSettingLeftHandednessInput!]!
  ) {
    updateWdtStudentSettingLeftHandedness(data: $data) {
      ...UpdateStudentSettingFragment
    }
  }
  ${UPDATE_STUDENT_SETTING_FRAGMENT}
`;

export default UPDATE_WDT_STUDENT_LEFT_HANDEDNESS_SETTING;
